module.exports = __webpack_public_path__ + "img/symbol_0.c91bf84e.png";